import React, { useState}  from 'react';
import { useDispatch , useSelector } from 'react-redux';

import {   defineFormuleShow} from '../../state/redux';


import { logocompagnie } from '../../images/images_logoscompagnies';


import { isclassblur } from '../../utils/radin';

import FormuleDetail from '../Contrats/FormuleDetail';
import CardFormuleJauge from './CardFormuleJauges';
import AjoutDevis from './AjoutDevis'
import Check from '../Check';


import './CardFormule.scss'
const classNames = require('classnames');
function formatprix(prix){
  return prix?   (Number(prix)?.toFixed(2).replace('.',',')):'0'}


const CardFormule = ({formule,typeliste,choicedformule, setChoicedformule, dispfiltrebesoins})=>{
     
     const idsNeeds= useSelector(state=>state.formules.idsNeeds) ;
     const classforneeds = idsNeeds?.includes(formule.id) && typeliste==='ficheclient' &&  !dispfiltrebesoins ; 


     const dispatch= useDispatch()
     const logo  = logocompagnie(formule?.compagnie?.toUpperCase());
     const c_appellation = formule.appellation && formule.appellation?.trim()?.length !==0 ;
     const c_lineaire = formule.type_tarif?.includes('lin') ||  formule.appellation?.includes('LIN') ;
     const etiquette = c_lineaire && c_appellation ?<div className='etiquette_container'><span className='etiquette lineaire'>{formule.appellation}</span></div>:
                       c_appellation ?<div className='etiquette_container'><span className='etiquette lowcost'>{formule.appellation}</span></div>:<></>
        

     
     const [showFormuleDetail,setShowFormuleDetail] = useState(false);
     
     const changeformulesigne = ()=>{choicedformule?.id===formule?.id?setShowFormuleDetail(false):setShowFormuleDetail(true); 
                                     choicedformule?.id===formule?.id?setChoicedformule({}):setChoicedformule(formule);}
     
     const showformule = (e)=>{ 
      const cond_click_toshow =typeliste==='ficheclient' && e.target.closest('.cardformule_last')===null && e.target.closest('.cardformulecheckformulesigne')===null ;
      cond_click_toshow && dispatch(defineFormuleShow({...formule})) ;
      typeliste==='souscription' && changeformulesigne() ; 
     }

    return (<div className={classNames("cardformule",{"classforneeds": classforneeds===true})}   >
                <div className="cardformuletop" id ={formule?.id} onClick={showformule}>
                    { typeliste === 'souscription' && <Check checked={formule?.id===choicedformule?.id }   />}
                      <div className='cardformuleimage' ><img src={logo}  width='70' alt='logoCompagnie'/></div>
                      <div className="nomformule" >              
                                   <span className="nomformule_span1">{formule?.gamme} </span>
                                   <span className={`nomformule_span2 ${isclassblur()}`}> { formule?.nom_formule +(formule.kdc? ' ( KDC ) ':'') } </span>     
                                   {etiquette}
                       </div>
                         <CardFormuleJauge  hospi={formule.hospi}  consults={formule.consults}
                                            optique_lunettes_nb={formule.optique_lunettes_nb} optique_lentilles_nb={formule.optique_lentilles_nb}
                                            dentaire_prothese_nb={formule.dentaire_prothese_nb} dentaire_implant_nb={formule.dentaire_implant_nb} 
                                            dentaire_orthodontie_nb ={formule.dentaire_orthodontie_nb}  prevention ={formule.prevention}
                          />
                        <div  className="cardformuleright" > 
                                   <span className={`cardformuleright_span1 ${isclassblur}`}  >{formatprix(formule?.prix)}€</span>
                                   <span className='cardformuleright_span2' >par mois</span>
                       </div> 
                     { typeliste === 'ficheclient' && <div className='cardformule_last'>
                                                            <AjoutDevis  formule={formule}  />
                                             </div>}
                </div>
                {((formule?.id===choicedformule?.id && showFormuleDetail) && typeliste === 'souscription') && 
                                                  <div className="cardformulebottom">
                                                       <FormuleDetail setShowFormuleDetail={setShowFormuleDetail} 
                                                                      choicedformule ={choicedformule} 
                                                                      setChoicedformule ={setChoicedformule}    />
                                                  </div>} 
          </div>)       
             
}

export default CardFormule